// src/components/filter.
import React, { useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import Select from "react-select"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { useFormik } from "formik"
import * as Yup from "yup"
import { Rating } from "react-simple-star-rating"
import { Link } from "react-router-dom"

const Feedbackreport = () => {
  //Grid form
  const formik = useFormik({
    initialValues: {
      firstname: "",
      email: "",
      password: "",
      city: "",
      state: "",
      zip: "",
      check: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("This field is required"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(RegExp("(.*[a-z].*)"), "At least lowercase letter")
        .matches(RegExp("(.*[A-Z].*)"), "At least uppercase letter")
        .matches(RegExp("(.*[0-9].*)"), "At least one number")
        .required("This field is required"),
      city: Yup.string().required("This field is required"),
      state: Yup.string().required("This field is required"),
      zip: Yup.string().required("This field is required"),
      check: Yup.string().required("This field is required"),
    }),

    onSubmit: values => {
      // console.log("value", values.password);
    },
  })

  const columns = useMemo(
    () => [
      {
        header: "W/O No",
        accessorKey: "wono",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "W/O Date adn Time",
        accessorKey: "wodate",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Customer Name",
        accessorKey: "custname",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Feedback call date Time",
        accessorKey: "feedbackcall",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Feedback Telecaller",
        accessorKey: "feedbactele",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "W/O telecaller",
        accessorKey: "wotele",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Filed Executive",
        accessorKey: "filedexe",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Overall Rating",
        accessorKey: "overallrate",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (
          <Rating
            size={25}
            initialValue={4}
            readonly
            onClick={function noRefCheck() {}}
          />
        ),
      },
      {
        header: "Telecaller Rating",
        accessorKey: "telecallerrate",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (
          <Rating
            size={25}
            initialValue={4}
            readonly
            onClick={function noRefCheck() {}}
          />
        ),
      },

      {
        header: "Filed Executive Rating",
        accessorKey: "filedexerating",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (
          <Rating
            size={25}
            initialValue={4}
            readonly
            onClick={function noRefCheck() {}}
          />
        ),
      },
      {
        header: "Show",
        accessorKey: "show",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="/Workorderfeedback"
                  className="btn btn-sm btn-soft-primary"
                  id={`viewtooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-eye-outline" />
                </Link>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`viewtooltip-${cellProps.row.original.id}`}
              >
                View
              </UncontrolledTooltip>
            </ul>
          )
        },
      },
    ],
    []
  )

  const data = [
    {
      wono: "W01233",

      wodate: "1-1-2024 5:45 PM",
      custname: "Avinash Sane",
      product: "Cockrouch-1R-Gel  Champ AMc",

      feedbackcall: "1-1-2024 5:45 PM",
      feedbactele: "7677484848",
      wotele: "10",
      filedexe: "6000",
      overallrate: "Semma Rane",
      telecallerrate: "Singapore",
      filedexerating: "Singapore",
      show: "Singapore",
    },
  ]

  //usestate
  const flatpickrRef = useRef(null)

  const showValue = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.open()
    }
  }

  const closeValue = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.close()
    }
  }
  //usestate
  //usestate
  const [selectedGroup, setselectedGroup] = useState(null)

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      label: "Picnic",
      options: [
        { label: "Mustard", value: "Mustard" },
        { label: "Ketchup", value: "Ketchup" },
        { label: "Relish", value: "Relish" },
      ],
    },
    {
      label: "Camping",
      options: [
        { label: "Tent", value: "Tent" },
        { label: "Flashlight", value: "Flashlight" },
        { label: "Toilet Paper", value: "Toilet Paper" },
      ],
    },
  ]

  //meta title
  document.title = "Data Tables | Skote - React Admin & Dashboard Template"

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row className="page-content">
          <Col xl={12}>
            <div>
              <Card>
                <CardBody>
                  <Breadcrumbs
                    title="Tables"
                    breadcrumbItem="Feed Back Report "
                  />

                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col xs={3}>
                        <div className="form-group mb-4">
                          <Label>From Date</Label>
                          <InputGroup>
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="dd M,yyyy"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                            />
                          </InputGroup>
                        </div>
                      </Col>

                      <Col xs={3}>
                        <div className="form-group mb-4">
                          <Label>To Date</Label>
                          <InputGroup>
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="dd M,yyyy"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                            />
                          </InputGroup>
                        </div>
                      </Col>

                      <Col xs={3} className="mb-4 mt-4">
                        <button type="submit" className="btn btn-primary w-md">
                          Submit
                        </button>
                      </Col>
                    </Row>
                  </Form>
                  <div className="">
                    <CardTitle className="mb-4">
                      Report of Emp Name for the date :
                    </CardTitle>
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isPagination={true}
                      SearchPlaceholder="27 records..."
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers"
                      tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
Feedbackreport.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Feedbackreport
